import type { ApiResponse } from '@court-sync/shared';
import { apiDelete, apiGet, apiPost } from './apiClient';

export interface SmsUsageResponse {
  sent: number;
  allowance: number;
  addonEnabled: boolean;
  periodEnd: string | null;
  smsEnabled: boolean;
  addonMonthlyPrice: number;
  addonCurrency: 'USD' | 'AUD';
}

export const subscriptionSmsService = {
  getUsage(): Promise<ApiResponse<SmsUsageResponse>> {
    return apiGet<SmsUsageResponse>('/subscription/sms-usage');
  },

  enableAddon(): Promise<ApiResponse<{ addonEnabled: boolean }>> {
    return apiPost<{ addonEnabled: boolean }>('/subscription/addons/sms', {});
  },

  disableAddon(): Promise<ApiResponse<{ addonEnabled: boolean }>> {
    return apiDelete<{ addonEnabled: boolean }>('/subscription/addons/sms');
  },
};
